import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

import "./intro.scss";

const HeroCanvas = lazy(() => import("./HeroCanvas"));

export default function Intro() {
  const [ready, setReady] = useState(false);
  const ballRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const go = () => {
      if (!cancelled) setReady(true);
    };
    const fallback = setTimeout(go, 700);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => setTimeout(go, 80));
    }
    return () => {
      cancelled = true;
      clearTimeout(fallback);
    };
  }, []);

  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduce) return undefined;
    const onMove = (e) => {
      const el = ballRef.current;
      if (!el) return;
      const dx = (e.clientX / window.innerWidth - 0.5) * 18;
      const dy = (e.clientY / window.innerHeight - 0.5) * 12;
      el.style.transform = `translate3d(${dx.toFixed(1)}px, ${dy.toFixed(1)}px, 0)`;
    };
    window.addEventListener("pointermove", onMove, { passive: true });
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  return (
    <section className={`hero${ready ? " is-ready" : ""}`} id="intro">
      <div className="hero-copy">
        <h1 className="hero-title">
          4 billion plays<span className="hero-dot">.</span>
        </h1>
        <p className="hero-sub">
          I co-founded Volleyball Legends, the biggest volleyball game in the
          world, and I build the backend that keeps it running.
        </p>
        <div className="hero-actions">
          <a className="btn primary" href="/#contact">
            Message me
            <span className="btn-icon"><ArrowUpRight size={16} weight="bold" /></span>
          </a>
          <Link className="btn glass plain" to="/experience">See the work</Link>
        </div>
      </div>

      <div className="hero-ball" aria-label="Interactive volleyball, drag to spin">
        <div className="hero-ball-track" ref={ballRef}>
          <div className="hero-glow" aria-hidden="true"></div>
          <div className="hero-canvas">
            <Suspense fallback={null}>
              <HeroCanvas />
            </Suspense>
          </div>
        </div>
        <span className="hero-hint label">Drag to spin</span>
      </div>
    </section>
  );
}
